"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.showTemplateSelect = exports.getTotalWithdrawValue = exports.getTotalRender = exports.getFinalBalanceWithdrawValue = exports.getAvailableBalance = void 0;
var _bignumber = _interopRequireDefault(require("bignumber.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var getTotalWithdrawValue = exports.getTotalWithdrawValue = function getTotalWithdrawValue(balance, amount, fee) {
  return amount + fee >= balance ? balance - fee : amount;
};
var getFinalBalanceWithdrawValue = exports.getFinalBalanceWithdrawValue = function getFinalBalanceWithdrawValue(balance, amount, fee) {
  return amount + fee <= balance ? balance - (amount + fee) : balance;
};
var getTotalRender = exports.getTotalRender = function getTotalRender(balance, amount, fee) {
  amount = parseFloat(amount);
  if (!amount) return 0;
  if (amount === balance) return amount;
  var total = getTotalWithdrawValue(balance, amount, fee);
  var totalBigNumber = new _bignumber["default"](total);
  var feeBigNumber = new _bignumber["default"](fee);
  return Number(totalBigNumber.plus(feeBigNumber));
};
var showTemplateSelect = exports.showTemplateSelect = function showTemplateSelect(_ref) {
  var templateTypes = _ref.templateTypes,
    templateInfo = _ref.templateInfo,
    isLoading = _ref.isLoading;
  return templateTypes.length > 1 && !Object.keys(templateInfo).length && !isLoading;
};
var getAvailableBalance = exports.getAvailableBalance = function getAvailableBalance(balance, hold) {
  return balance ? balance - hold : 0;
};